import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BRAND_ABOUT_PAGE, BRAND_HOME_PAGE, BRAND_NOTICE_PAGE, BRAND_PRODUCTS_PAGE, BRAND_QNA_PAGE } from "@/settings/constant";
import { Stack, styled } from "@mui/material";
import React from "react";
import { BrandLNBMobile } from "./BrandLNBMobile";
import { BrandLNBPc } from "./BrandLNBPc";
export const LINKS = [
    {
        name: "홈",
        path: BRAND_HOME_PAGE,
        index: 0,
        match: "exact"
    },
    {
        name: "상품",
        path: BRAND_PRODUCTS_PAGE,
        index: 1,
        match: "startsWith"
    },
    {
        name: "공지",
        path: BRAND_NOTICE_PAGE,
        index: 2,
        match: "startsWith"
    },
    {
        name: "Q&A",
        path: BRAND_QNA_PAGE,
        index: 3,
        match: "startsWith"
    },
    {
        name: "소개",
        path: BRAND_ABOUT_PAGE,
        index: 4,
        match: "exact"
    }
];
export const ContentsSection = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BrandLNBMobile, {
                links: LINKS
            }),
            /*#__PURE__*/ _jsx(ContentsSectionContainer, {
                children: /*#__PURE__*/ _jsxs(StyledStack, {
                    children: [
                        /*#__PURE__*/ _jsx(BrandLNBPc, {
                            links: LINKS
                        }),
                        /*#__PURE__*/ _jsx(ChildrenContainer, {
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
const ContentsSectionContainer = styled("section")((param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.palette.divider),
        [theme.breakpoints.down("lg")]: {
            borderTop: "none"
        }
    };
});
const StyledStack = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "1200px",
        margin: "0 auto",
        gap: "56px",
        padding: "40px 0",
        display: "flex",
        flexDirection: "row",
        [theme.breakpoints.down("lg")]: {
            padding: "32px 0"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "28px 0"
        }
    };
});
const ChildrenContainer = styled("section")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        [theme.breakpoints.down("lg")]: {}
    };
});
